import React from 'react';
import Shell from '@/components/Shell';
import { luxe } from '@/lib/luxe';
import { ManageTabs } from '@/components/ManagePanels';

export default function Manage() {
  return (
    <Shell>
      <div className="mb-6" data-testid="manage-page">
        <h1 className="font-display text-3xl font-black" style={{ color: luxe.text }}>Manage</h1>
        <p className="text-sm" style={{ color: luxe.muted }}>Connectors, payments, secrets and AI providers — admin controls over existing secure backends.</p>
      </div>
      <ManageTabs initial="connectors" />
    </Shell>
  );
}
